import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBrhYVVDw9TwDRsYA61pvU3Be3DWSNZo28",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "chessisfun-66b29.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "chessisfun-66b29",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "chessisfun-66b29.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "745788597509",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:745788597509:web:7a57f394e8f36b855fc36c",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-NCFZX4RBKY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { app, db };
export default app;

